import {Company, CurrentUser} from "@/types/user";

const getCompanyListForMenu = (
    currentUser: CurrentUser,
    callBack: (company:Company) => void
) => {
    const companyHistoryJson = localStorage.getItem("company_history");
    const companyHistory = companyHistoryJson ? JSON.parse(companyHistoryJson) : [];

    const companyList = currentUser.companies || [];
    const selectedCompanyId = currentUser.selectedCompany?.id;

    // Check if companies in history exist in user's company list
    const validHistory = companyHistory.filter((historyItem: { id: string }) =>
        companyList.some((company) => company.id === historyItem.id)
    );

    // Start with selected company if available
    let sortedCompanies = selectedCompanyId
        ? [companyList.find((c) => c.id === selectedCompanyId)].filter(Boolean) as typeof companyList
        : [];

    // Add companies from valid history, avoiding duplicates
    sortedCompanies = [
        ...sortedCompanies,
        ...validHistory
        .filter((c: { id: string }) => !sortedCompanies.find((sc) => sc.id === c.id))
        .slice(0, 3 - sortedCompanies.length),
    ];

    // If we still need more companies, add from companyList
    if (sortedCompanies.length < 3) {
        const additionalCompanies = companyList
        .filter((c) => !sortedCompanies.find((sc) => sc.id === c.id))
        .slice(0, 3 - sortedCompanies.length);
        sortedCompanies = [...sortedCompanies, ...additionalCompanies];
    }

    // Add "All Stores" option if we have at least 3 companies
    if (companyList.length > 3) {
        sortedCompanies.push({
            id: null,
            name: "All Stores",
            store_name: "All stores",
        });
    }

    // Map to final menu structure
    return sortedCompanies.map((company) => {
        return {
            title: <span className={"capitalize"}>{company.name}</span>,
            icon: selectedCompanyId === company.id ? "" : (company.id === null ? "" : ""),
            className: (selectedCompanyId !== company.id && company.id !== null) ? "text-gray-400 hover:text-gray-900" : "",
            onClick: () => {
                callBack(company);
            },
        };
    });
};

export default getCompanyListForMenu;
